import { PageIdentityEnum } from "../../../enums/page-identity.enum"
import { ITableFilterSetState } from "../interfaces/table-filter-set.sate"
import { TablesState } from "../interfaces/tables-state"
import { DEFAULT_FILTER_SETS } from "./filter-set-static/filter-set-static.data"

export namespace FilterSetActionHandlers {
    export const fetchFilterSetsHandler = function (state: TablesState, tableId: PageIdentityEnum) {
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: DEFAULT_FILTER_SETS[tableId] ?? [] }
        }
    }

    export const fetchFilterSetsSuccessHandler = function (state: TablesState, tableId: string, filterSets: ITableFilterSetState[]) {
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: filterSets }
        }
    }

    export const fetchFilterSetsFailedHandler = function (state: TablesState, tableId: string, filterSets: ITableFilterSetState[]) {
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: filterSets }
        }
    }

    export const setActiveSets = function (state: TablesState, tableId: string, setIds: number[]) {
        const oldFilter = state[tableId].filterSets;
        const updatedFilters = oldFilter.map(f => ({ ...f, active: setIds.includes(f.id) }));
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: updatedFilters }
        }
    }
    export const reset = function (state: TablesState, tableId: string) {
        const oldFilter = state[tableId].filterSets;
        const updatedFilters = oldFilter.map(f => ({ ...f, active: false }));
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: updatedFilters }
        }
    }

    export const deactivateSets = function (state: TablesState, tableId: string, setIds: number[]) {
        const sets = state[tableId].filterSets;
        const updated = sets.map(f => setIds.includes(f.id) ? { ...f, active: false } : f);
        return {
            ...state,
            [tableId]: { ...state[tableId], filterSets: updated }
        }
    }

    export const exclusiveGroupToggle = function (state: TablesState, tableId: string, setId: number, groupIds: number[]) {
        const sets = state[tableId].filterSets;
        const isActive = sets.find(f => f.id === setId)?.active ?? false;
        const updated = sets.map(f => {
            if (!groupIds.includes(f.id)) return f;
            if (f.id === setId) return { ...f, active: !isActive };
            return { ...f, active: false };
        });
        return { ...state, [tableId]: { ...state[tableId], filterSets: updated } };
    }

    export const independentToggle = function (state: TablesState, tableId: string, setId: number) {
        const sets = state[tableId].filterSets;
        const updated = sets.map(f => f.id === setId ? { ...f, active: !f.active } : f);
        return { ...state, [tableId]: { ...state[tableId], filterSets: updated } };
    }
}